import React, { useEffect, useState } from 'react';
import api from './api';
import Login from './pages/Login';
import Portal from './pages/Portal';
import TermsGate from './pages/TermsGate';
import { detectLang, setLangStored, makeT } from './i18n';

export default function App() {
  const [lang, setLangState] = useState(detectLang());
  const [phase, setPhase] = useState('loading'); // loading | login | terms | portal
  const [me, setMe] = useState(null);
  const [data, setData] = useState(null);

  const t = makeT(lang);
  const setLang = (l) => { setLangStored(l); setLangState(l); };
  const initialError = new URLSearchParams(window.location.search).get('e') === '1';

  const boot = async () => {
    try {
      const m = await api.me();
      setMe(m);
      if (!m.termsAccepted) { setPhase('terms'); return; }
      const d = await api.summary();
      setData(d);
      setPhase('portal');
    } catch {
      setPhase('login');
    }
  };

  useEffect(() => { boot(); }, []);

  const logout = async () => { try { await api.logout(); } catch {} window.location.href = '/'; };

  if (phase === 'loading') return <div className="center"><div className="muted">{t('loading')}</div></div>;
  if (phase === 'login') return <Login t={t} lang={lang} setLang={setLang} initialError={initialError} />;
  if (phase === 'terms') return <TermsGate t={t} lang={lang} setLang={setLang} onAccepted={() => { setPhase('loading'); boot(); }} />;
  return <Portal t={t} lang={lang} setLang={setLang} data={data} email={me.email} onLogout={logout} />;
}
